module.exports = __webpack_public_path__ + "img/image113.49f22a1e.jpg";